// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"66843d10","251":"28a99ceb","275":"d5efd19f","282":"6a4d4ad8","556":"a00c8add","591":"28dfb38b","608":"b73312b2","630":"cf33ea4c","643":"bb9b1f3f","737":"3c7bd96d","789":"830a089e"}[chunkId] + ".chunk.js";
};